import { Button, CompoundTag, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { Pagination } from "@package/ui-components";
import {
  ITEM_GRID_PER_PAGE_DEFAULT,
  ITEM_GRID_PER_PAGE_OPTIONS,
} from "../../constants/constants";

export type ItemGridPaginationProps = {
  defaultPerPage?: number;
  defaultPerPageOptions?: number[];
  onPageChanged?: (page: number) => void;
  onPerPageChanged?: (perPage: number) => void;
  page?: number;
  perPage?: number;
  totalItems: number;
  unlimited?: boolean;
};

export function ItemGridPagination({
  defaultPerPage = ITEM_GRID_PER_PAGE_DEFAULT,
  defaultPerPageOptions = ITEM_GRID_PER_PAGE_OPTIONS,
  onPageChanged,
  onPerPageChanged,
  page = 0,
  perPage = defaultPerPage,
  totalItems,
  unlimited = false,
}: ItemGridPaginationProps) {
  return (
    <div className="flex flex-row justify-end mt-1">
      <div className="pt-1">
        <Select<number>
          items={defaultPerPageOptions}
          itemRenderer={(value, { handleClick, handleFocus, modifiers }) => (
            <MenuItem
              active={modifiers.active}
              disabled={modifiers.disabled}
              key={value}
              onClick={handleClick}
              onFocus={handleFocus}
              roleStructure="listoption"
              text={value}
            />
          )}
          activeItem={perPage}
          filterable={false}
          onItemSelect={(value) => onPerPageChanged?.(value)}
        >
          <Button
            minimal
            text={`Page Size: ${perPage}`}
            rightIcon="caret-down"
          />
        </Select>
      </div>
      <div className="ml-2 pt-1">
        <Pagination
          page={page + 1}
          pageSize={perPage}
          totalItems={totalItems}
          onPageChange={(count) => onPageChanged?.(count - 1)}
          unlimited={unlimited}
        />
      </div>
      {!unlimited && (
        <div className="ml-2">
          <CompoundTag minimal leftContent="Total" className="mt-2">
            {totalItems}
          </CompoundTag>
        </div>
      )}
    </div>
  );
}
